/* @flow */

import { tablet } from '@braindate/ui/lib/token/mediaQuery';

export default {
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  right: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [tablet]: {
      justifyContent: 'flex-end',
    },
  },
  avatarQueue: {
    display: 'none',

    [tablet]: {
      display: 'flex',
    },
  },
};
